import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import store from "./redux/store";
import App from "./App";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

//* Add this script to your app
function fixVh(): void {
  const vh: number = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}
fixVh();
window.addEventListener("resize", fixVh);
// console.log("window.screen:", window.screen);

root.render(
  //* React.Fragment instead of React.StrictMode -> shows errors about react-transition-group
  <React.Fragment>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.Fragment>
);
